import { ReportAttributes, ReportRelationships } from 'dashboard/models/report';
import { ApiModel, ApiResource } from 'lib/interfaces/api';

export enum EmailAddressReputation {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
  NONE = 'none',
}

export enum EmailDomainReputation {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
  NA = 'n/a',
}

export interface ReportEmailAddressAttributes extends ReportAttributes {
  'email-address'?: string;
  'email-reputation'?: EmailAddressReputation;
  'email-reference-count'?: number;
  'email-domain-reputation'?: EmailDomainReputation;
  'email-domain-age-days'?: number;
  'email-first-seen-days'?: number;
  'email-last-seen-days'?: number;
  'email-is-suspicious'?: boolean;
  'email-is-blocklisted'?: boolean;
  'email-is-disposable'?: boolean;
  'email-is-spam'?: boolean;
  'email-is-deliverable'?: boolean;
  'email-is-valid-mx'?: boolean;
  'email-domain-exists'?: boolean;
  'email-is-free-provider'?: boolean;
  'email-domain'?: string;
  'email-malicious-activity-detected-recent'?: boolean;
  'email-credentials-leaked-recent'?: boolean;
}

export type ReportEmailAddress = ApiResource<
  ReportEmailAddressAttributes,
  ReportRelationships,
  ApiModel.ReportEmailAddress
>;
